import React, { type FC, type PropsWithChildren } from 'react'

type RenderWhenProps = PropsWithChildren<{ condition: boolean }>

const RenderWhen: FC<RenderWhenProps> = ({ condition, children }) =>
  condition ? <>{children}</> : null

export default RenderWhen
